<div class="container-sm my-3">
    <div class="mt-5"></div>
    <div [formGroup]="formGroup">
        <!-- FORESIGHT -->
        <div class="form-group row my-3">
            <label for="foresight" class="col-4 col-form-label">{{ "survey.new.savings.foresight" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="foresight" formControlName="foresight">
                    <option *ngFor="let key of ['A', 'B', 'C', 'D']" [value]="key">
                        {{ "survey.domain.savings.foresight." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(foresight)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- OBJECTIVES -->
        <div class="form-group row my-3">
            <label for="objectives" class="col-4 col-form-label">{{ "survey.new.savings.objectives" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="objectives" formControlName="objectives">
                    <option *ngFor="let key of ['A', 'B', 'C']" [value]="key">
                        {{ "survey.domain.savings.objectives." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(objectives)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- KNOWLEDGE -->
        <div class="form-group row">
            <label class="col-4 col-form-label">{{ "survey.new.savings.knowledge" | translate }}</label>
            <div class="col-8">
                <div class="border rounded mb-1">
                    <div>
                        <mat-checkbox color="primary" class="d-block" formControlName="knowledge1">{{ "survey.domain.savings.knowledge.1" | translate }}</mat-checkbox>
                    </div>
                    <div>
                        <mat-checkbox color="primary" class="d-block" formControlName="possession1">{{ "survey.domain.savings.knowledge.possession" | translate }}</mat-checkbox>
                    </div>
                    <div class="text-secondary fst-italic ms-1 mb-1" *ngIf="!knowledge1?.value && !!possession1?.value">
                        <fa-icon class="mx-2" [icon]="['fas', 'triangle-exclamation']"></fa-icon>
                        <small>{{ "survey.new.savings.knowledge-hint" | translate }}</small>
                    </div>
                </div>
                <div class="border rounded mb-1">
                    <div>
                        <mat-checkbox color="primary" class="d-block" formControlName="knowledge2">{{ "survey.domain.savings.knowledge.2" | translate }}</mat-checkbox>
                    </div>
                    <div>
                        <mat-checkbox color="primary" class="d-block" formControlName="possession2">{{ "survey.domain.savings.knowledge.possession" | translate }}</mat-checkbox>
                    </div>
                    <div class="text-secondary fst-italic ms-1 mb-1" *ngIf="!knowledge2?.value && !!possession2?.value">
                        <fa-icon class="mx-2" [icon]="['fas', 'triangle-exclamation']"></fa-icon>
                        <small>{{ "survey.new.savings.knowledge-hint" | translate }}</small>
                    </div>
                </div>
                <div class="border rounded mb-1">
                    <div>
                        <mat-checkbox color="primary" class="d-block" formControlName="knowledge3">{{ "survey.domain.savings.knowledge.3" | translate }}</mat-checkbox>
                    </div>
                    <div>
                        <mat-checkbox color="primary" class="d-block" formControlName="possession3">{{ "survey.domain.savings.knowledge.possession" | translate }}</mat-checkbox>
                    </div>
                    <div class="text-secondary fst-italic ms-1 mb-1" *ngIf="!knowledge3?.value && !!possession3?.value">
                        <fa-icon class="mx-2" [icon]="['fas', 'triangle-exclamation']"></fa-icon>
                        <small>{{ "survey.new.savings.knowledge-hint" | translate }}</small>
                    </div>
                </div>
                <div class="border rounded mb-1">
                    <div>
                        <mat-checkbox color="primary" class="d-block" formControlName="knowledge4">{{ "survey.domain.savings.knowledge.4" | translate }}</mat-checkbox>
                    </div>
                    <div>
                        <mat-checkbox color="primary" class="d-block" formControlName="possession4">{{ "survey.domain.savings.knowledge.possession" | translate }}</mat-checkbox>
                    </div>
                    <div class="text-secondary fst-italic ms-1 mb-1" *ngIf="!knowledge4?.value && !!possession4?.value">
                        <fa-icon class="mx-2" [icon]="['fas', 'triangle-exclamation']"></fa-icon>
                        <small>{{ "survey.new.savings.knowledge-hint" | translate }}</small>
                    </div>
                </div>
                <div class="border rounded">
                    <div>
                        <mat-checkbox color="primary" class="d-block" formControlName="knowledge5">{{ "survey.domain.savings.knowledge.5" | translate }}</mat-checkbox>
                    </div>
                </div>
            </div>
        </div>

        <!-- OPERATION -->
        <div class="form-group row my-3">
            <label for="operation" class="col-4 col-form-label">{{ "survey.new.savings.operation" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="operation" formControlName="operation">
                    <option *ngFor="let key of ['A', 'B', 'C']" [value]="key">
                        {{ "survey.domain.savings.operation." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(operation)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- INVESTMENT -->
        <div class="form-group row my-3">
            <label for="investment" class="col-4 col-form-label">{{ "survey.new.savings.investment" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="investment" formControlName="investment">
                    <option *ngFor="let key of ['A', 'B', 'C', 'D', 'E']" [value]="key">
                        {{ "survey.domain.savings.investment." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(investment)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- INVESTMENT FINANCIAL -->
        <div class="form-group row my-3">
            <label for="investmentFinancial" class="col-4 col-form-label">{{ "survey.new.savings.investment-financial" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="investmentFinancial" formControlName="investmentFinancial">
                    <option *ngFor="let key of ['A', 'B', 'C', 'D']" [value]="key">
                        {{ "survey.domain.savings.investment-financial." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(investmentFinancial)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- FAMILY INCOME -->
        <div class="form-group row my-3">
            <label for="familyIncome" class="col-4 col-form-label">{{ "survey.new.savings.family-income" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="familyIncome" formControlName="familyIncome">
                    <option *ngFor="let key of ['A', 'B', 'C', 'D', 'E']" [value]="key">
                        {{ "survey.domain.savings.family-income." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(familyIncome)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- FAMILY INCOME SOURCE -->
        <div class="form-group row my-3">
            <label for="familyIncomeSource" class="col-4 col-form-label">{{ "survey.new.savings.family-income-source" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="familyIncomeSource" formControlName="familyIncomeSource">
                    <option *ngFor="let key of ['A', 'B', 'C', 'D', 'E']" [value]="key">
                        {{ "survey.domain.savings.family-income-source." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(familyIncomeSource, 'required')">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
                <mat-hint class="text-secondary fst-italic" *ngIf="hasFamilyIncomeSourceIncongruence('familyIncomeSource')">
                    <fa-icon class="mx-2" [icon]="['fas', 'triangle-exclamation']"></fa-icon>
                    <small>{{ "data-table.incongruence.family-income-source" | translate }}</small>
                </mat-hint>
            </div>
        </div>

        <!-- INCOME SAVINGS -->
        <div class="form-group row my-3">
            <label for="incomeSavings" class="col-4 col-form-label">{{ "survey.new.savings.income-savings" | translate }}</label>
            <div class="col-8">
                <input min="0" max="100" suffix="%" mask="separator.0" thousandSeparator="." type="text" class="form-control" id="incomeSavings" formControlName="incomeSavings" [attr.disabled]="completed">
                <mat-error *ngIf="hasError(incomeSavings)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- RISK PROPENSITY -->
        <div class="form-group row my-3">
            <label for="riskPropensity" class="col-4 col-form-label">{{ "survey.new.savings.risk-propensity" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="riskPropensity" formControlName="riskPropensity">
                    <option *ngFor="let key of ['A', 'B', 'C']" [value]="key">
                        {{ "survey.domain.savings.risk-propensity." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(riskPropensity)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- RISK TOLERANCE -->
        <div class="form-group row my-3">
            <label for="riskTolerance" class="col-4 col-form-label">{{ "survey.new.savings.risk-tolerance" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="riskTolerance" formControlName="riskTolerance">
                    <option *ngFor="let key of ['A', 'B', 'C']" [value]="key">
                        {{ "survey.domain.savings.risk-tolerance." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(riskTolerance)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- RISK CHOICE -->
        <div class="form-group row my-3">
            <label for="riskChoice" class="col-4 col-form-label">{{ "survey.new.savings.risk-choice" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="riskChoice" formControlName="riskChoice">
                    <option *ngFor="let key of ['A', 'B', 'C']" [value]="key">
                        {{ "survey.domain.savings.risk-choice." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(riskChoice)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- DECORRELATION -->
        <div class="form-group row my-3">
            <label for="decorrelation" class="col-4 col-form-label">{{ "survey.new.savings.decorrelation" | translate }}</label>
            <div class="col-8">
                <select class="form-control" id="decorrelation" formControlName="decorrelation">
                    <option *ngFor="let key of ['A', 'B', 'C']" [value]="key">
                        {{ "survey.domain.savings.decorrelation." + key | translate }}
                    </option>
                </select>
                <mat-error *ngIf="hasError(decorrelation)">
                    {{ "data-table.validation.field-required" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- SUBMIT -->
        <button *ngIf="isInsert()" class="btn btn-primary mt-5 next-step" [disabled]="completed" (click)="onSubmit()">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            {{ "survey.new.protection.next" | translate }}
        </button>
    </div>
</div>
